import { create } from 'apisauce'
import {
  URL_API,
  ADMIN_API,
  CONTABIL_API,
  FINANCEIRO_API,
  FISCAL_API,
  FOLHA_API,
  AUTOMACAO_API,
  TFE_API,
  JETTAX_API,
} from 'src/constants/config'
import { headers, interceptorsRequest, responseTransform } from 'src/lib/interceptors'

const API = create({ baseURL: URL_API, headers: headers })

API.addResponseTransform(responseTransform)
API.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_ADMIN = create({ baseURL: ADMIN_API, headers: headers })

API_ADMIN.addResponseTransform(responseTransform)
API_ADMIN.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_CONTABIL = create({ baseURL: CONTABIL_API, headers: headers })

API_CONTABIL.addResponseTransform(responseTransform)
API_CONTABIL.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_FINANCEIRO = create({ baseURL: FINANCEIRO_API, headers: headers })

API_FINANCEIRO.addResponseTransform(responseTransform)
API_FINANCEIRO.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_FISCAL = create({ baseURL: FISCAL_API, headers: headers })

API_FISCAL.addResponseTransform(responseTransform)
API_FISCAL.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_FOLHA = create({ baseURL: FOLHA_API, headers: headers })

API_FOLHA.addResponseTransform(responseTransform)
API_FOLHA.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_AUTOMACAO = create({ baseURL: AUTOMACAO_API, headers: headers })

API_AUTOMACAO.addResponseTransform(responseTransform)
API_AUTOMACAO.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_TFE = create({ baseURL: TFE_API, headers: headers })

API_TFE.addResponseTransform(responseTransform)
API_TFE.axiosInstance.interceptors.request.use(interceptorsRequest)

const API_JETTAX = create({ baseURL: JETTAX_API, headers: headers })

API_JETTAX.addResponseTransform(responseTransform)
API_JETTAX.axiosInstance.interceptors.request.use(interceptorsRequest)

export { API, API_ADMIN, API_CONTABIL, API_FINANCEIRO, API_FISCAL, API_FOLHA, API_AUTOMACAO, API_TFE, API_JETTAX }
